import { useState } from 'react';
import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { animeFaqs } from '@/mocks/animeData';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="w-full py-16 md:py-24">
      <div className="px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-12">
          <div className="lg:col-span-4">
            <Reveal>
              <SectionHeading
                eyebrow="FAQ"
                title="漫迷问答"
                description="关于页面内容、筛选方式与观看节奏的几个常见问题，点开标题即可查看回答。"
              />
              <div className="mt-6 flex items-start gap-3 rounded-lg bg-secondary-50 border border-secondary-200/70 p-4">
                <i className="ri-question-answer-line text-xl text-secondary-600"></i>
                <p className="text-xs md:text-sm text-secondary-900 leading-relaxed">
                  还有别的疑问？多试几次页面上的筛选与搜索，大部分使用问题都能自己找到答案。
                </p>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-8">
            <div className="space-y-3">
              {animeFaqs.map((faq, index) => {
                const isOpen = openIndex === index;
                return (
                  <Reveal key={faq.q} delay={index * 50}>
                    <div
                      className={`rounded-lg border transition-colors ${
                        isOpen
                          ? 'bg-background-100 border-primary-300'
                          : 'bg-background-100 border-background-200/70'
                      }`}
                    >
                      <button
                        type="button"
                        onClick={() => setOpenIndex(isOpen ? -1 : index)}
                        aria-expanded={isOpen}
                        className="w-full flex items-center justify-between gap-4 text-left px-4 md:px-5 py-4 cursor-pointer"
                      >
                        <span className="font-heading text-sm md:text-base font-bold text-foreground-950">
                          {faq.q}
                        </span>
                        <i
                          className={`flex-shrink-0 text-xl text-primary-500 transition-transform duration-300 ${
                            isOpen ? 'ri-subtract-line rotate-180' : 'ri-add-line'
                          }`}
                        ></i>
                      </button>
                      <div
                        className={`overflow-hidden transition-all duration-500 ${
                          isOpen ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'
                        }`}
                      >
                        <p className="px-4 md:px-5 pb-4 text-xs md:text-sm text-foreground-600 leading-relaxed">
                          {faq.a}
                        </p>
                      </div>
                    </div>
                  </Reveal>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}